<script setup>
import { ref } from "vue";

defineProps({
  label: { type: String, required: true },
  icon: { type: String, default: "fa-plus" },
  disabled: { type: Boolean, default: false },
});

defineEmits(["click"]);

const buttonRef = ref(null);

defineExpose({
  focus: () => buttonRef.value?.focus(),
});
</script>

<template>
  <button
    ref="buttonRef"
    type="button"
    class="btn btn-link btn-xs mb-0 p-0 link-button"
    :disabled="disabled"
    @click.prevent="$emit('click')"
  >
    <i :class="['fa', icon, 'me-1']" aria-hidden="true"></i>{{ label }}
  </button>
</template>

<style scoped>
.link-button:focus {
  border-radius: 4px !important;
  box-shadow: 0 0 8px 0 rgba(148, 163, 184, 0.6) !important;
  outline: none !important;
}
</style>
